module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="xFormMetricItemBarWrapper">\n  <div class="xFormMetricItemBar" style="width: '+
((__t=( metricWidth ))==null?'':_.escape(__t))+
';"></div>\n</div>\n<div class="xFormMetricItemCountWrapper">\n  <label class="xFormMetricItemCount" style="margin-left: '+
((__t=( metricWidth ))==null?'':_.escape(__t))+
';">'+
((__t=( metricValue ))==null?'':_.escape(__t))+
'</label>\n</div>\n';
}
return __p;
};
